import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a5dc8da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-detail" }
const _hoisted_2 = {
  key: 0,
  class: "account-tips"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("该客服的账号已被停用，禁止登录。可重新")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("，或者")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("该客服。")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("注册邮件已发出。请通知该客服，点击邮件中的链接，设置登录密码，即可完成注册。")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("该客服尚未完成注册，账号不可用。可")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("该客服，或者")
const _hoisted_9 = { key: 3 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("客服基本信息，请在")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("中修改删除")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tips" }, "填写真实姓名，便于工作协同和统计绩效。", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tips" }, "面向客户的称谓，客服人员可自行修改。", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tips" }, "填写真实存在的邮箱地址，以便接收注册邮件。", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tips" }, "客服收信后，点击链接设置密码完成注册，在此之前，账号处于待验证状态，不可用", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tips" }, "请填写常用邮箱，便于用邮件处理工单。", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tips" }, "验证的手机或邮箱才可作为客服账号。", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tips" }, "为客服设置手机账号，客服人员可使用手机号登录系统或找回密码。", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-tips" }, "当集成第三方登录时，可以通过匹配ExternalId进行登录", -1))
const _hoisted_20 = { class: "page-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("停用账号")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_role_select = _resolveComponent("role-select")!
  const _component_service_desk_tag_select = _resolveComponent("service-desk-tag-select")!
  const _component_service_desk_select = _resolveComponent("service-desk-select")!
  const _component_ewei_tags_select = _resolveComponent("ewei-tags-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ((_ctx.engineer.id && (_ctx.engineer.user.status === 0 || (_ctx.engineer.user.status === 2 && _ctx.sendEmailSuccess) || (_ctx.engineer.user.status === 2 && !_ctx.sendEmailSuccess))) || _ctx.hadSunloginWeb)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.engineer.id && _ctx.engineer.user.status === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_3,
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleEnable(true))),
                    style: {"color":"#1e8cce"}
                  }, "启用账号"),
                  _hoisted_4,
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteEngineer && _ctx.handleDeleteEngineer(...args))),
                    style: {"color":"#1e8cce"}
                  }, "删除"),
                  _hoisted_5
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.engineer.id && _ctx.engineer.user.status === 2 && _ctx.sendEmailSuccess)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_6
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.engineer.id && _ctx.engineer.user.status === 2 && !_ctx.sendEmailSuccess)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_7,
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteEngineer && _ctx.handleDeleteEngineer(...args))),
                    style: {"color":"#1e8cce"}
                  }, "删除"),
                  _hoisted_8,
                  _createElementVNode("a", {
                    style: {"color":"#1e8cce"},
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSendEmailAgain && _ctx.handleSendEmailAgain(...args)))
                  }, "重发注册邮件")
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.engineer.id && (_ctx.engineer.user.status === 0 || (_ctx.engineer.user.status === 2 && _ctx.sendEmailSuccess) || (_ctx.engineer.user.status === 2 && !_ctx.sendEmailSuccess)) && _ctx.hadSunloginWeb)
              ? (_openBlock(), _createElementBlock("br", _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.hadSunloginWeb)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _hoisted_10,
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleModifyAccount && _ctx.handleModifyAccount(...args))),
                    style: {"color":"#1e8cce"}
                  }, "向日葵管理平台>账号管理"),
                  _hoisted_11
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form, {
        class: "account-detail-form",
        "label-col": { span: 4 },
        "wrapper-col": { span: 20 },
        labelAlign: "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, _mergeProps({ label: "客服姓名" }, _ctx.validateInfos['user.name']), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.engineer.user.name,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.engineer.user.name) = $event)),
                disabled: _ctx.hadSunloginWeb,
                maxlength: 32,
                allowClear: ""
              }, null, 8, ["value", "disabled"]),
              _hoisted_12
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_form_item, _mergeProps({ label: "客服昵称" }, _ctx.validateInfos['nickname']), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.engineer.nickname,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.engineer.nickname) = $event)),
                disabled: _ctx.hadSunloginWeb,
                maxlength: 32,
                allowClear: ""
              }, null, 8, ["value", "disabled"]),
              _hoisted_13
            ]),
            _: 1
          }, 16),
          (_ctx.engineer.user.emailExamined || (_ctx.engineer.user.status === 2 && _ctx.engineer.user.email))
            ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                key: 0,
                label: "客服邮箱"
              }, _ctx.validateInfos['user.email']), {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.engineer.user.email,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.engineer.user.email) = $event)),
                    disabled: _ctx.engineer.id > 0,
                    maxlength: 128,
                    allowClear: ""
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.engineer.id)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_14,
                            _hoisted_15,
                            _hoisted_16
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64)),
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, _mergeProps({ label: "手机号" }, _ctx.validateInfos['user.mobilePhone']), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.engineer.user.mobilePhone,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.engineer.user.mobilePhone) = $event)),
                disabled: _ctx.engineer.id > 0,
                maxlength: 16,
                allowClear: ""
              }, null, 8, ["value", "disabled"]),
              _hoisted_18
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_form_item, { label: "ExternalId" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.engineer.user.externalId,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.engineer.user.externalId) = $event)),
                maxlength: 16,
                allowClear: ""
              }, null, 8, ["value"]),
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, _mergeProps({ label: "客服角色" }, _ctx.validateInfos['role.id']), {
            default: _withCtx(() => [
              _createVNode(_component_role_select, {
                modelValue: _ctx.engineer.role.id,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.engineer.role.id) = $event)),
                disabled: _ctx.disabledRoleSelect,
                "filter-role-name-key": _ctx.filterRoleNameKey,
                allowClear: ""
              }, null, 8, ["modelValue", "disabled", "filter-role-name-key"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_form_item, _mergeProps({ label: "所属客服组" }, _ctx.validateInfos['serviceDeskIds']), {
            default: _withCtx(() => [
              (_ctx.hadSunloginWeb)
                ? (_openBlock(), _createBlock(_component_a_input, {
                    key: 0,
                    value: _ctx.engineer.serviceDeskNames,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.engineer.serviceDeskNames) = $event)),
                    disabled: true
                  }, null, 8, ["value"]))
                : (_openBlock(), _createBlock(_component_service_desk_tag_select, {
                    key: 1,
                    modelValue: _ctx.engineer.serviceDeskIds,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.engineer.serviceDeskIds) = $event)),
                    serviceDeskStatus: "1",
                    onChange: _ctx.checkDefaultServiceDesk,
                    allowClear: ""
                  }, null, 8, ["modelValue", "onChange"]))
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_form_item, _mergeProps({ label: "首选客服组" }, _ctx.validateInfos['defaultServiceDesk.id']), {
            default: _withCtx(() => [
              _createVNode(_component_service_desk_select, {
                modelValue: _ctx.engineer.defaultServiceDesk.id,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.engineer.defaultServiceDesk.id) = $event)),
                "option-ids": _ctx.engineer.serviceDeskIds,
                allowClear: ""
              }, null, 8, ["modelValue", "option-ids"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_form_item, { label: "标签" }, {
            default: _withCtx(() => [
              _createVNode(_component_ewei_tags_select, {
                tags: _ctx.engineer.user.tags,
                who: "user",
                onTagChange: _ctx.handleTagChange,
                whoid: _ctx.engineer.user.id
              }, null, 8, ["tags", "onTagChange", "whoid"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "并发会话上限范围",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_group, {
                compact: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps(_ctx.validateInfos['minConcurrentChatNumber'], { style: {"width":"calc(50% - 16px)"} }), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.engineer.minConcurrentChatNumber,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.engineer.minConcurrentChatNumber) = $event)),
                        type: "number"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 16),
                  _createVNode(_component_a_input, {
                    style: {"width":"30px","pointer-events":"none","background-color":"#fff"},
                    placeholder: "~",
                    disabled: ""
                  }),
                  _createVNode(_component_a_form_item, _mergeProps(_ctx.validateInfos['maxConcurrentChatNumber'], { style: {"width":"calc(50% - 15px)"} }), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.engineer.maxConcurrentChatNumber,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.engineer.maxConcurrentChatNumber) = $event)),
                        type: "number"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_20, [
      (_ctx.engineer.id > 0)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            onClick: _ctx.handleSubmit,
            type: "primary",
            disabled: !_ctx.hasPermission('engieer_update'),
            style: {"margin-right":"10px"},
            loading: _ctx.isLoading
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "loading"]))
        : (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            onClick: _ctx.handleSubmit,
            type: "primary",
            disabled: !_ctx.hasPermission('engieer_create'),
            style: {"margin-right":"10px"},
            loading: _ctx.isLoading
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "loading"])),
      (_ctx.engineer.id > 0 && !_ctx.engineer.isCreator && _ctx.engineer.user.status === 1)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 2,
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleEnable(false))),
            type: "danger",
            disabled: !_ctx.hasPermission('engieer_update'),
            style: {"margin-right":"10px"},
            loading: _ctx.isLoading
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }, 8, ["disabled", "loading"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}